/**
 * Global constants for the BagpipeBlasphemy application.
 * This file centralizes constants used across different components and modules.
 */

// Game Constants
export const BLASTER_HIGH_SCORE_KEY = 'blaster_high_score';
export const MAX_MISSES = 5;

// User Data Constants
export const BAGPIPE_USER_INITIALS_KEY = 'bagpipe_user_initials';

// UI Constants

// Audio Constants
export const DEFAULT_GAIN = 3.0;
export const GLOBAL_GAIN_KEY = 'global_gain_value';
export const MIN_GAIN = 0.5;
export const MAX_GAIN = 10.0;

// Global Settings Keys
export const GLOBAL_CHANTER_KEY = 'global_selected_chanter';
export const GLOBAL_CHANTER_ID_KEY = 'global_selected_chanter_id';
export const GLOBAL_MIC_KEY = 'global_microphone_device';

// Fixed chanter UUIDs
export const STANDARD_CHANTER_UUID = 'c0000000-0000-0000-0000-000000000001';
export const KEYBOARD_CHANTER_UUID = 'c0000000-0000-0000-0000-000000000002';

// Default audio settings
export const DEFAULT_AUDIO_SETTINGS = {
  requiredConsecutiveMatches: 1,
  clarityThreshold: 0.2,
  toleranceAdjustment: 0,
  maxHistory: 5,
  gain: DEFAULT_GAIN
};

// Social Media URLs
export const FACEBOOK_URL = 'https://www.facebook.com/people/Bagpipe-Blasphemy/61575988768010/'; 